import React from "react";
import { FaUsers, FaCalendarAlt, FaMapMarkerAlt } from "react-icons/fa";

interface TimelineEventosProps {
  eventos: Evento[];
}

const formatFecha = (iso: string) => {
  const date = iso.split("T")[0];
  const [year, month, day] = date.split("-");
  return { year, display: `${day}/${month}/${year}` };
};

const TimelineEventos: React.FC<TimelineEventosProps> = ({ eventos }) => {
  return (
    <div className="relative mx-auto max-w-5xl">
      <div className="absolute left-1/2 top-4 hidden h-[98%] w-px -translate-x-1/2 bg-gradient-to-b from-blue-500 via-indigo-400 to-purple-500 sm:block" />
      <div className="space-y-10">
        {eventos.map((evento, index) => {
          const { year, display } = formatFecha(evento.fecha);
          const isLeft = index % 2 === 0;

          return (
            <div
              key={evento.acontecimiento_id}
              className="relative grid grid-cols-1 items-start gap-6 sm:grid-cols-12"
            >
              <div
                className={`sm:col-span-5 ${
                  isLeft ? "sm:order-1 sm:text-right" : "sm:order-3 sm:text-left"
                }`}
              >
                <div className="inline-flex items-center gap-3 rounded-full bg-slate-100 px-4 py-2 text-xs font-semibold uppercase tracking-wide text-slate-600">
                  <FaCalendarAlt className="h-4 w-4 text-blue-500" />
                  {year}
                </div>
                <p className="mt-2 text-sm text-slate-500">
                  {isLeft ? "Evento destacado" : "Hito en la agenda"}
                </p>
              </div>

              <div className="relative flex items-center justify-center sm:col-span-2 sm:order-2">
                <div
                  className={`flex h-12 w-12 items-center justify-center rounded-full border-4 bg-white shadow-md ${
                    isLeft
                      ? "border-blue-100 text-blue-600"
                      : "border-green-100 text-green-600"
                  }`}
                >
                  <span className="text-sm font-semibold">{index + 1}</span>
                </div>
              </div>

              <div
                className={`sm:col-span-5 ${
                  isLeft ? "sm:order-3" : "sm:order-1"
                }`}
              >
                <div className="rounded-2xl bg-white p-6 shadow-lg transition duration-200 hover:-translate-y-1 hover:shadow-xl">
                  {(evento.imagen_url || evento.imagen) && (
                    <img
                      src={evento.imagen_url || evento.imagen}
                      alt={evento.nombre}
                      className="mb-4 h-40 w-full rounded-xl object-cover"
                    />
                  )}
                  <div className="flex items-center justify-between gap-3">
                    <h3 className="text-lg font-semibold text-slate-900">
                      {evento.nombre}
                    </h3>
                    <span className="rounded-full bg-blue-50 px-3 py-1 text-xs font-semibold text-blue-700">
                      {display}
                    </span>
                  </div>
                  <p className="mt-2 text-sm text-slate-600">
                    {evento.descripcion}
                  </p>
                  <div className="mt-3 space-y-2 text-sm text-slate-600">
                    <div className="flex items-center gap-2">
                      <FaMapMarkerAlt className="h-4 w-4 text-blue-500" />
                      <span>{evento.ubicacion?.nombre || "Ubicación pendiente"}</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <FaUsers className="h-4 w-4 text-blue-500" />
                      <span>{evento.socios?.length ?? 0} participantes</span>
                    </div>
                  </div>
                  <div className="mt-4 flex items-center gap-2">
                    <button className="flex-1 rounded-lg bg-blue-600 px-4 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-blue-700">
                      Ver detalle
                    </button>
                    <span className="rounded-lg bg-slate-100 px-3 py-1 text-xs font-semibold text-slate-600">
                      #{evento.acontecimiento_id}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TimelineEventos;
